import TonWeb from 'tonweb';

export function flipAddressType(address: string) {
  if (!address) return '';
  return address.includes(':')
    ? new TonWeb.utils.Address(address).toString(true, true, true)
    : new TonWeb.utils.Address(address).toString(false, false, true);
}

export function flipAddressBouncableType(address: string) {
  if (!address) return '';
  if (address.length !== 48) return '';
  const isBouncable = address.startsWith('E');
  const bouncableAddress = new TonWeb.utils.Address(address).toString(true, true, true);
  const nonBouncableAddress = new TonWeb.utils.Address(address).toString(true, true, false);
  return isBouncable ? nonBouncableAddress : bouncableAddress;
}
